var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#662d91;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-839.533,444.1a2.006,2.006,0,0,0,2,2h8a2.006,2.006,0,0,0,2-2v-12h-12Zm13-15h-3.5l-1-1h-5l-1,1h-3.5v2h14Z",
    transform: "translate(840.533 -428.101)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBin);
export default __webpack_public_path__ + "static/media/icon_bin.27bfedfca166b4ae9dac90b04e9d9a6d.svg";
export { ForwardRef as ReactComponent };